export default "__VITE_ASSET__DJlYPPh1__"